import React from 'react';
import styles from './SectionTitle.module.scss';

interface Props {
  title_jp: string;
}

const SectionTitle = ( props: Props ) => {
  return (
    <div className={styles.SectionTitle}>
      <p className={styles.title}>{ props.title_jp }</p>
    </div>
  );
};

export default SectionTitle;
